import { Box } from '@mui/material'
import { IProjectDTO } from 'data/dtos/automation/i-project-dto'
import { Fragment } from 'react'
import { useHistory } from 'react-router-dom'
import ChipStatus from 'utils/project/chip-status'
import ChipText from 'utils/project/chip-text'
import BadgeConnector from 'utils/project/connector-badge'
import { useStyles } from './styles'

interface ProjectListCard {
  project: IProjectDTO
  organizationId: string
  withoutTags?: boolean
  contractId: string
}

const ProjectListCard = ({ project, withoutTags = false, organizationId, contractId }: ProjectListCard) => {
  const classes = useStyles()
  const history = useHistory()

  const handleNavigate = () => history.push(`/projects/${project.id}/${organizationId}/${contractId}`)

  const apps = project?.recipes?.filter((recipe) => recipe.type == 'app')

  return (
    <Box
      className={classes.root}
      onClick={handleNavigate}
    >
      <div className={classes.header}>
        <h2>{project?.name}</h2>
        <ChipStatus text={project?.status} />
      </div>

      {!withoutTags && (
        <div className={classes.subHeader}>
          {project?.tags.map((tag, index) => (
            <ChipText
              key={index}
              text={tag}
              color='processing'
            />
          ))}
        </div>
      )}

      <div className={classes.footer}>
        <div className={classes.item}>
          <p>Conectores</p>

          <div className={classes.connectorsBox}>
            {project?.connectors.map((connector, index) => (
              <BadgeConnector
                key={index}
                name={connector.name}
                index={index}
              />
            ))}
          </div>
        </div>

        <div className={classes.item}>
          {apps?.length > 0 && (
            <Fragment>
              <p>Apps</p>

              <div className={classes.connectorsBox}>
                {apps?.map((connector, index) => (
                  <BadgeConnector
                    key={index}
                    name={connector.appName}
                    index={index}
                  />
                ))}
              </div>
            </Fragment>
          )}
        </div>
      </div>
    </Box>
  )
}

export default ProjectListCard
